import { useForm } from "react-hook-form";
import { Controller } from "react-hook-form";
import SelectCategories from "../Selects/Categories";
import { useEffect, useRef, useState } from "react";
import { t } from "i18next";
import useTailwindBreakpoint from "../../../hooks/useTailwindBreakpoint";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SearchItem = ({ formData, setFormData, className = null }) => {
  const form = useForm();
  const itemCategory = form.watch("itemCategory");
  const name = form.watch("name");

  const [viewMenu, setViewMenu] = useState(true);
  const currentBp = useTailwindBreakpoint();

  const formSubmitBtn = useRef();
  const itemSubCategoryRef = useRef();
  const itemCategoryRef = useRef();

  useEffect(() => {
    setViewMenu(["sm", "md", "lg"].includes(currentBp) ? false : true);
  }, [currentBp]);

  const handleSubmit = () => {
    formSubmitBtn.current.click();
  };

  let timeout;

  useEffect(() => {
    timeout = setTimeout(() => {
      if (formData || (name && name !== "")) {
        handleSubmit();
      }
    }, 350);
    return () => clearTimeout(timeout);
  }, [name]);

  useEffect(() => {
    if (itemCategory === null) {
      form.setValue("itemSubCategory", null);
    }
  }, [itemCategory]);

  return (
    <>
      <form
        onSubmit={form.handleSubmit((data) => setFormData(data))}
        className={`grid grid-cols-12 items-baseline gap-3 py-4 rounded-md bg-white ${
          className && className
        }`}
        autoComplete="off"
      >
        {["sm", "md", "lg"].includes(currentBp) && (
          <div
            className={`col-span-12 flex justify-between items-center ${
              viewMenu && "border-b pb-4 mb-4"
            }`}
          >
            <div className="text-md font-bold">Critères de recherche</div>
            <div>
              <FontAwesomeIcon
                icon={faPlus}
                onClick={() => setViewMenu(!viewMenu)}
                className={`${
                  viewMenu && "rotate-45"
                } text-lg transition-all font-bold cursor-pointer`}
              />
            </div>
          </div>
        )}

        <div
          className={`${
            !viewMenu ? "hidden" : "block"
          } col-span-12 lg:col-span-4`}
        >
          <label>{t("shop.search.name")}</label>
          <div>
            <input
              type="text"
              className="w-full"
              {...form.register("name")}
              name="name"
            />
          </div>
        </div>

        <div
          className={`${
            !viewMenu ? "hidden" : "block"
          } col-span-12 lg:col-span-4`}
        >
          <label>{t("items.category")}</label>
          <Controller
            control={form.control}
            name="itemCategory"
            render={({ field: { onChange, onBlur, value } }) => (
              <SelectCategories
                myRef={itemCategoryRef}
                onBlur={onBlur}
                onChange={(e) => {
                  onChange(e);
                  form.setValue("itemSubCategory", null);
                  handleSubmit();
                  itemSubCategoryRef.current.clearValue();
                }}
                value={value}
                isClearable={true}
              />
            )}
          />
        </div>

        <div
          className={`${
            !viewMenu ? "hidden" : "block"
          } col-span-12 lg:col-span-4 lg:ml-3`}
        >
          <label>{t("items.subCategory")}</label>
          <Controller
            control={form.control}
            name="itemSubCategory"
            render={({ field: { onChange, onBlur, value } }) => (
              <SelectCategories
                onBlur={onBlur}
                onChange={(e) => {
                  onChange(e);
                  handleSubmit();
                }}
                myRef={itemSubCategoryRef}
                value={value}
                isDisabled={!itemCategory}
                isClearable={true}
                parentCategory={itemCategory}
              />
            )}
          />
        </div>

        <input type="submit" className="hidden" ref={formSubmitBtn} />
      </form>
    </>
  );
};

export default SearchItem;
